export default Object.freeze({
  TITLE: '쇼핑몰 관리자 접속 안내',
  DESCRIPTION:
    'shop by 쇼핑몰 관리자는 크롬, 웨일, 엣지 브라우저에 최적화 되어 있습니다.\n다른 브라우저에서는 일부 기능이 제한될 수 있으니\n원활한 서비스 이용을 위해 아래와 같이 이용 부탁 드립니다.',
  DESCRIPTION_TO_COPY_DOMAIN: '관리자 주소 복사 클릭',
  DESCRIPTION_TO_GO_SUPPORTED_BROWSER: '최적화된 브라우저에 관리자 주소\n입력(붙여넣기) 후 접속',
  DESCRIPTION_TO_DOWNLOAD_BROWSER: '최적화된 브라우저는 하단 아이콘을 클릭하시면 다운받을 수 있습니다.',
  IN_ON_EFFORT_TO_UPDATE_OUR_SYSTEM: '더 나은 서비스를 제공하기 위해 더욱 노력하겠습니다.\n감사합니다.',
  ONLY_ADMIN_NOTICE: '※ 관리자만 해당되며 쇼핑몰은 크롬, 웨일, 엣지 뿐 아니라 IE11, safari등에서도 이용 가능합니다',
  COPY_DOMAIN: '관리자 주소 복사',
  DOWNLOAD: '다운로드',
  ALERT_COPIED_DOMAIN: '쇼핑몰 관리자 주소가\n정상적으로 복사되었습니다.',
  
  CHROME: '크롬',
  WHALE: '웨일',
  EDGE: '엣지',
});
